module.exports = require('./lib/query-selector');